export default "__VITE_ASSET__XW1_3TiF__";